import React, {useEffect, useRef, useState} from 'react';
import SearchService from "services/Search";
import PubSub from "services/PubSub/";
import TagManagerService from "services/TagManager";
import StorageService from "services/StorageService";
import { withRouter } from "react-router";
import { addClass, removeClass, cleanSearch } from 'utils';
import PropTypes from "prop-types";
import InputSearch from "components/HelpCenter/InputSearch";
import style from './style.scss'; //NOSONAR

let searchTime = null;
let initScroll = 0;
let scrollTime = null;
let actions = [];
let isModalAutocomplete = false;
let service = true;
let sourceApp = false;

const Search = (props) => {
    const [isLoading, setLoading] = useState(false);
    const [search, setSearch] = useState('');
    const [position, setPosition] = useState(-1);
    const [submitted, setSubmitted] = useState(false);
    const [suggestions, setSuggestions] = useState([]);
    const [historySearch, setHistorySearch] = useState([]);
    const [modalAutocomplete, setModalAutocomplete] = useState(false);
    const [sticky, setSticky] = useState(true);
    const searchInput = useRef(null);

    useEffect(() => {
        return function cleanup(){
            StorageService.removeItem('history_search_help_center');
            service = true;
        }
    },[]);

    const getContent = (inputValue) => {
        if(!inputValue) return false;
        SearchService.searchSuggesionsHelp(inputValue.toLowerCase(), true, true).then(results => {
            if(!isModalAutocomplete || !results){
                return false;
            }

            setSuggestions((!results.length) ? [] : results);

            isModalAutocomplete =  true;
            setModalAutocomplete(isModalAutocomplete);

            setLoading(false);
            setPosition(-1);

            if(typeof document !== 'undefined'){
                addClass(document.documentElement, 'non-scroll');
            }
        });
    };

    useEffect(()=> {
        clearTimeout(searchTime);
        searchTime = setTimeout(() => {
            const inputValue = cleanSearch(search);
            if (inputValue.length >= 2) {
                setLoading(true);
                if(service){
                    getContent(inputValue);
                }

            } else {
                setLoading(false);
                setSuggestions([]);
            }

        }, 300);
    }, [search]);

    const onChange = (event) => {
        let inputValue = event.target.value;
        setSearch(inputValue);
        service = true;
    };

    const onFocus = () => {
        isModalAutocomplete = true;
        setModalAutocomplete(isModalAutocomplete);
        setSubmitted(false);

        if(document) {
            addClass(document.documentElement, 'non-scroll');
        }

        TagManagerService.clickHeader('Search', 'Header Help Center');

        const _historySearch = JSON.parse(StorageService.getItem('history_search_help_center')) || [];
        setHistorySearch(_historySearch);

        if(search){
            getContent(search);
        }
        service = true;
    };

    const closeModalAutocomplete = () => {
        isModalAutocomplete = false;
        setModalAutocomplete(isModalAutocomplete);
        setLoading(false);

        if(document){
            removeClass(document.documentElement, 'non-scroll');
        }

        if(!search){
            setSuggestions([]);
        }

        clearTimeout(searchTime);
    };

    const goBack = (event) => {
        event.preventDefault();
        closeModalAutocomplete();
    };

    const onSubmit = (event, i, searchTerm = '') => {
        setSubmitted(true);

        let searchQuery = searchTerm ?  searchTerm : cleanSearch(search.toLowerCase());
        if(event) event.preventDefault();

        const indexPosition = (i || i === 0) ? i : position;

        if(search.length === 0 && indexPosition === -1){
            return false;
        }

        let arrayItems = '';

        if(!search.length) {
            arrayItems = historySearch;
        } else {
            arrayItems = suggestions;
        }
        let suggestionClean = '';
        let suggestion = '';

        if(typeof arrayItems[indexPosition] === 'object'){
            suggestion = arrayItems[indexPosition] ? arrayItems[indexPosition].slug : search;
            suggestionClean = arrayItems[indexPosition] ? cleanSearch(arrayItems[indexPosition].label) : search;
        } else {
            suggestionClean = arrayItems[indexPosition] ? cleanSearch(arrayItems[indexPosition]) : search;
        }

        if(indexPosition > -1 && !searchTerm){
            props.history.push(`/centro-ayuda/${suggestion ? suggestion : suggestionClean}`);
            setSearch(suggestionClean);
        } else {
            if(!suggestions.length){
                props.history.push(`/centro-ayuda/busqueda/${searchQuery}`);
            } else {
                const cleanSuggestion = cleanSearch(searchQuery);
                props.history.push(`/centro-ayuda/busqueda/${cleanSuggestion}`);
            }
        }

        saveOnHistory(suggestionClean);
        document.activeElement.blur();
        closeModalAutocomplete();
    };

    const removeHistory = ( i) => {
        const _historySearch = JSON.parse(StorageService.getItem('history_search_help_center')) || [];
        _historySearch.splice(i,1);
        StorageService.setItem('history_search_help_center', JSON.stringify(_historySearch));
        setHistorySearch(_historySearch);
        getContent();
    }

    const saveOnHistory = (suggestionClean) => {
        const searchQuery = cleanSearch(suggestionClean);
        const _historySearch = JSON.parse(StorageService.getItem('history_search_help_center')) || [];

        if(search !== ''){
            if(_historySearch.indexOf(searchQuery.toLowerCase()) === -1){
                if(_historySearch.length <= 11){

                    _historySearch.unshift(searchQuery.toLowerCase());
                    StorageService.setItem('history_search_help_center', JSON.stringify(_historySearch));

                } else if(_historySearch.length === 12){

                    _historySearch.pop();
                    _historySearch.unshift(searchQuery.toLowerCase());
                    StorageService.setItem('history_search_help_center', JSON.stringify(_historySearch));
                }
            } else {
                _historySearch.splice(_historySearch.indexOf(searchQuery));
            }
        }
    };

    const clearSearch = (event) => {
        event.preventDefault();
        setSuggestions([]);
        setHistorySearch([]);
        setSearch('');
        setTimeout(()=>{
            searchInput.current.focus();
        }, 0);
    };

    const scrollVerify = () => {
        if(typeof window === 'undefined') return false;
        clearTimeout(scrollTime);
        scrollTime = setTimeout(() => {
            if(isModalAutocomplete) return false;
            const pos = window.scrollY;
            const isSticky = pos <= initScroll || pos === 0;

            if(isSticky !== sticky){
                setSticky(isSticky);
            }
        }, 0);
    };

    const startScroll = () => {
        if(typeof window === 'undefined') return false;
        initScroll = window.scrollY;
    };

    useEffect(() => {
        actions.push(PubSub.register('product_redirect', closeModalAutocomplete));
        actions.push(PubSub.register('search_redirect', closeModalAutocomplete));
        actions.push(PubSub.register('toggle_search', () => {
            setModalAutocomplete(true);
            setTimeout(() => {
                searchInput.current.focus();

            }, 0);
        }));

        if(!search.length && !historySearch.length){
            setPosition(-1);
        }

        if(typeof document !== 'undefined') {
            document.addEventListener('keydown', _keyDown);
        }

        return function cleanup(){
            if(typeof document !== 'undefined') {
                document.removeEventListener('keydown', _keyDown);
            }
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    });

    useEffect(() => {

        if (typeof window !== 'undefined') {
            window.addEventListener("touchend", scrollVerify);
            window.addEventListener("touchmove", startScroll);
        }

        return function cleanup(){
            if (typeof window !== 'undefined') {
                window.removeEventListener("touchend", scrollVerify);
                window.removeEventListener("touchmove", startScroll);
            }
        }

    }, [sticky]);

    const _keyDown = (data) => {
        let arrayLength = '';

        if(!search.length) {
            arrayLength = historySearch.length;
        } else {
            arrayLength = suggestions.length;
        }

        if(isModalAutocomplete) {
            var pos;

            switch (data.keyCode) {
                case 40:
                    data.preventDefault();
                    pos = position + 1;
                    if(pos > arrayLength) {
                        pos = 0;
                    }
                    setPosition(pos);
                    break;
                case 38:
                    data.preventDefault();
                    pos = position - 1;
                    if(pos < -1) break;
                    setPosition(pos);
                    break;
                case 27:
                    data.preventDefault();
                    document.activeElement.blur();
                    closeModalAutocomplete();
                    break;
            }
        }
    };

    const setSearchItem = (searchItem, i) => {
        let item = '';
        const typeObj = typeof searchItem === 'object';
        if(typeObj) {
            item = searchItem.label.toLowerCase();
        } else {
            item = searchItem.toLowerCase();
        }
        service = false;
        setSearch(item);
        onSubmit(null, i, !typeObj ? item : false);
    }

    const resultsProps = {
        isLoading,
        search,
        modalAutocomplete,
        position,
        suggestions,
        historySearch,
        setSearchItem,
        removeHistory
    };

    if(typeof window !== 'undefined' && window.location.href.includes('?source=app')){
        sourceApp = true;
    }

    return <div className={'help-header-search '+ ((modalAutocomplete && !submitted) ? ' active ' : '') + (sticky ? ' sticky ' : '') + (sourceApp ? ' active-source ' : '')}>
        <InputSearch ref={searchInput} onSubmit={onSubmit} goBack={goBack} onFocus={onFocus} onChange={onChange} search={search} clearSearch={clearSearch} modalAutocomplete={modalAutocomplete} submitted={submitted} closeModalAutocomplete={closeModalAutocomplete} resultsProps={resultsProps}/>
    </div>;
};

Search.propTypes = {
    history: PropTypes.object
};

export default withRouter(Search);
